export const core = {
  deposit: 'Depositar',
  wallet: 'CARTERA',
};
